module.exports = __webpack_public_path__ + "icon-junit.fVRR2Aly.svg";